export const PROCESSING_LIST = [
    ['appName', 'APP名称'],
    ['channelName', '渠道包名称'],
    ['platform', '包体位数'],
    ['verName', '渠道包版本号'],
    ['verCode', 'Version Code'],
    ['createTime', '创建时间'],
    ['updateTime', '更新时间'],
    ['status', '任务状态描述'],
]

export const TASK_STATUS = {
    WAIT_CHECK: 1 << 0, // 等待校验
    CHECK: 1 << 1, // 校验中
    ERROR: 1 << 2, // 错误(任务结束)
    SUBMIT_AUDIT: 1 << 3, // 提交审核(任务结束)
}
export const TASK_STATUS_NAME = {
    [TASK_STATUS.WAIT_CHECK]: '等待校验',
    [TASK_STATUS.CHECK]: '校验中',
    [TASK_STATUS.ERROR]: '错误',
    [TASK_STATUS.SUBMIT_AUDIT]: '任务处理结束',
}
export const TASK_STATUS_LIST = [
    {
        label: '全部状态',
        value: -1,
    },
].concat(
    Object.values(TASK_STATUS).map(status => {
        return {
            label: TASK_STATUS_NAME[status],
            value: status,
        }
    })
)
